<template>
    <div>
        <div class="import-mask" @click="closeImport">
            <div class="content" @click.stop="fun">
                <!--选择要导入的供应商数据-->
                <div class="be-importing">
                    <span class="already-imported">
                        已导入的数据
                    </span>
                    <ul class="supplier-list" @scroll="loadMoreSupplier" ref="supplier_list">
                        <li v-for="item in list" :key="item.id" @click="showSupplier(item)" ref="supplier_list_item">{{item.name}}</li>
                    </ul>
                    <span class="add-new-import" @click="show_search_box = true">+添加</span>
                </div>
                <!--选择要同步共享的数据-->
                <div class="be-sharing" v-if="list.length > 0">
                    <div class="chose-import">
                        <span>需要导入<span class="imported-user">&nbsp;{{now_plank_supplier.name}}&nbsp;</span>的商品</span>
                        <ul>
                            <li v-for="(plank_item, plank_index) in plank_data" :key="plank_index">
                                <input type="checkbox" v-model="checkImported" :value="plank_item.name">
                                <span @click="changeCheck(plank_item.name)">{{plank_item.name}}</span>
                            </li>
                        </ul>
                    </div>
                    <div class="content-operation">
                        <span @click="deleteImportedData">删除此项</span>
                        <span @click="addNewData">保存&导入</span>
                    </div>
                </div>
                <div class="be-sharings" v-else>
                    <span>请先添加一个供应商用户</span>
                </div>
            </div>
        </div>
        <div class="add-new-mask" @click.stop="closeSearchBox" v-if="show_search_box">
            <div class="add-new-data" @click.stop="fun">
                <div class="add-new-title">导入他人数据</div>
                <div>
                    <input type="text" placeholder="对方柜柜号码" maxlength='11' v-model="other_guigui_tel" @keyup.enter="addOtherUser">
                    <span @click="addOtherUser">确定</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            //选择要导入的数据
            plank_data: [
                {name: '板材'},
                {name: '封边'},
                {name: '五金'},
                {name: '柜门'},
            ],
            // 供应商列表
            list: [],
            // 当前供应商配置
            now_plank_supplier: '',
            // 记录选择要导入的数据
            checkImported: [],
            // 显示搜索
            show_search_box: false,
            // 其他用户的柜柜账号
            other_guigui_tel: null,
            // 记录当前页
            page: 1,
            // 记录供应商列表单项高度
            supplier_item_height: null,
            // 记录防抖定时器
            clock: null,
        }
    },
    computed:{
        supplier_id(){
            if(this.$store.state.supplierInfo){
                return this.$store.state.supplierInfo.id
            }else{
                return 0
            }
        },
    },
    methods:{
        // 点击关闭导入弹窗
        closeImport(){
            this.$emit('closeImport', false);
        },
        // 点击关闭搜索弹窗
        closeSearchBox(){
            this.show_search_box = false;
            this.other_guigui_tel = null;
        },
        // 防止触发关闭弹窗事件
        fun(){},
        // 显示供应商配置
        showSupplier(item){
            this.now_plank_supplier = item;
        },
        // 搜索柜柜用户
        addOtherUser(){
            let flag = false;
            // 如果是已有账号, 则不能重复添加
            if(this.list.length > 0){
                flag = this.list.some(x => x.guigui_no === this.other_guigui_tel)
            }
            if(flag){
                this.$message('该账号已经添加, 不可重复添加!')
                return;
            }
            this.$requests.addCopyInfo(
                JSON.stringify({
                    uid: this.userInfo.id,
                    supplier_id: this.supplier_id,
                    guigui_no: this.other_guigui_tel,
                })
            ).then(res => {
                if(res.status == 1){
                    this.getImportedData();
                    this.show_search_box = false;
                }else{
                    this.$message('未搜索到账号信息!')
                }
            })
        },
        // 删除导入的供应商记录
        deleteImportedData(){
            this.$requests.deleteCopyInfo(
                JSON.stringify({
                    ids: [this.now_plank_supplier.id],
                    uid: this.userInfo.id,
                    supplier_id: this.supplier_id,
                })
            ).then(res => {
                if(res.status == 1){
                    console.log(this.now_plank_supplier)
                    // 删除视觉上的变化
                    for(let i in this.list){
                        if(this.list[i].id == this.now_plank_supplier.id){
                            this.list.splice(i, 1);
                        }
                    }
                    this.getImportedData()
                    this.$message({
                        type: 'success',
                        message: '删除成功'
                    })
                }
            })
        },
        // 添加新的导入数据
        addNewData(){
            let obj = {
                guigui_no: this.now_plank_supplier.guigui_no,
                supplier_id: this.supplier_id,
                uid: this.userInfo.id,
                copy_condition: {
                    plank: 0,
                    edge: 0,
                    hardware: 0,
                    door: 0,
                },
            };
            for(let i in this.checkImported){
                switch (this.checkImported[i]){
                    case '板材': obj.copy_condition.plank = 1;
                                break;
                    case '封边': obj.copy_condition.edge = 1;
                                break;
                    case '五金': obj.copy_condition.hardware = 1;
                                break;
                    case '柜门': obj.copy_condition.door = 1;
                                break;
                }
            }
            this.$requests.copySupplierCommodity(
                JSON.stringify(obj)
            ).then(res => {
                if(res.data.status == 1){
                    this.$message({
                        type: 'success',
                        message: '导入成功'
                    })
                    this.$emit('closeImport', true);
                }
            })
        },
        // 设置点击文字也可以触发选中不选中事件
        changeCheck(item){
            if(this.checkImported.includes(item)){
                this.checkImported.splice(this.checkImported.findIndex(x => x === item), 1)
            }else{
                this.checkImported.push(item);
            }
        },
        // 获取已导入的供应商记录
        getImportedData(){
            this.$requests.getCopyInfo(
                JSON.stringify({
                    uid: this.userInfo.id,
                    supplier_id:  this.supplier_id,
                    page: this.page,
                    limit: 12,
                })
            ).then(res => {
                let arr = res.data.copy_list.filter(x => this.list.every(y => x.id !== y.id))
                if(arr.length > 0){
                    arr.forEach(x => this.list.push(x))
                }
                if(this.list.length > 0){
                    this.$nextTick(() => {
                        this.supplier_item_height = this.$refs.supplier_list_item[0].offsetHeight
                    })
                }
                // 默认展示第一个数据
                this.now_plank_supplier = this.list[0];
            })
        },
        // 供应商列表加载更多
        loadMoreSupplier(){
            // 如果没有数据则不执行该函数
            if(this.supplier_item_height == null){
                return
            }
            let orderHeight = 60 + (this.page - 1) * this.supplier_item_height * 12;
            this.$nextTick(() => {
                let scroll_top = this.$refs.supplier_list.scrollTop;
                let client_height = this.$refs.supplier_list.clientHeight;
                let scroll_height = this.$refs.supplier_list.scrollHeight
                // 防止滚动触发多次请求
                if (this.clock) {
                    clearTimeout(this.clock);
                }
                this.clock = setTimeout(() => {
                    if (this.$refs.supplier_list.scrollTop > orderHeight) {
                        setTimeout(() => {
                            ++this.page;
                            this.getImportedData();
                        }, 1000)
                    } else if((scroll_top + client_height) == scroll_height) {
                        // 如果没有更多数据且已经滑到最底部的时候提示
                        this.$message('没有更多数据了!')
                    }
                }, 100)
            })
        },
    },
    mounted(){
        this.userInfo = JSON.parse(window.localStorage.getItem('data'));
        // 默认全部选中
        this.plank_data.forEach(item => this.checkImported.push(item.name));
        this.getImportedData();
    }
}
</script>

<style scoped lang="less">
ul{
    list-style: none;
    margin: 0;
    padding: 0;
    li{
        list-style: none;
    }
}
.import-mask{
    background: #0008;
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: 2;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    .content{
        position: fixed;
        top: 200px;
        left: 0;
        right: 0;
        margin: auto;
        width: 750px;
        height: 300px;
        background: #fff;
        display: flex;
        .be-importing{
            width: 200px;
            height: 100%;
            text-align: left;
            border-right: 1px solid #000;
            box-sizing: border-box;
            padding: 40px 15px 55px 15px;
            .already-imported{
                position: absolute;
                top: 15px;
                left: 15px;
                cursor: default;
            }
            .add-new-import{
                position: absolute;
                bottom: 15px;
                left: 15px;
                display: inline-block;
                width: 80px;
                height: 30px;
                text-align: center;
                line-height: 30px;
                cursor: pointer;
                border: 1px solid #000;
                border-radius: 7px;
                box-sizing: border-box;
            }
            .supplier-list{
                height: 100%;
                overflow: auto;
                /* 超出隐藏 */
                li{
                    font-size: 18px;
                    font-weight: bold;
                    width: 100%;
                    cursor: pointer;
                    overflow: hidden;
                    text-overflow:ellipsis;
                    white-space: nowrap;
                    display: block;
                    border-bottom: 1px solid #eee;
                    box-sizing: border-box;
                    &:hover{
                        background: rgba(99, 118, 247, 0.1);
                    }
                }
                /* 改造滚动条样式 */
                &::-webkit-scrollbar{
                    width: 5px;
                    height: 10px;
                }
                &::-webkit-scrollbar-thumb{
                    background: rgba(0, 0, 0, .05);
                }
                &:hover::-webkit-scrollbar-thumb {
                    background-color: rgba(0,0,0,.2);
                    border-radius: 10px;
                }
                &::-webkit-scrollbar-thumb:hover {
                    background-color: rgba(0,0,0,.4);
                }
                &::-webkit-scrollbar-track {
                    border-radius: 10px;
                    background-color: white;
                }
                &::-webkit-scrollbar-track:hover {
                    background-color: rgba(0,0,0,.01);
                }
            }
        }
        .be-sharings{
            width: 100%;
            line-height: 300px;
            text-align: center;
            span{
                color: #333;
                font-size: 20px;
                font-weight: bold;
            }
        }
        .be-sharing{
            width: 100%;
            padding: 15px 50px 15px 15px;
            box-sizing: border-box;
            .chose-import{
                text-align: left;
                width: 100%;
                span{
                    cursor: default;
                }
                .imported-user{
                    color: #333;
                    font-weight: bold;
                    font-family: PingFang SC;
                    // font-style:italic;
                }
                ul{
                    display: flex;
                    justify-content: space-around;
                    padding: 40px 0;
                    height: 205px;
                    &::before,&::after{
                        display: block;
                        content: "";
                        clear: both;
                    }
                    li{
                        display: flex;
                        align-items: center;
                        input{
                            margin-right: 5px;
                            cursor: pointer;
                        }
                        span{
                            cursor: pointer;
                        }
                    }
                }
            }
            .chose-share{
                text-align: left;
                width: 100%;
                padding-top: 15px;
                ul{
                    display: flex;
                    justify-content: space-around;
                    padding: 30px 0;
                    &::before,&::after{
                        display: block;
                        content: "";
                        clear: both;
                    }
                    li{
                        display: flex;
                        align-items: center;
                        input{
                            margin-right: 5px;
                            cursor: pointer;
                        }
                        span{
                            cursor: pointer;
                        }
                    }
                }
            }
            .content-operation{
                display: flex;
                justify-content: space-between;
                align-items: center;
                span{
                    cursor: pointer;
                }
                span:first-child{
                    color: #00f;
                }
                span:last-child{
                    width: 100px;
                    height: 30px;
                    text-align: center;
                    line-height: 30px;
                    background: #41c7db;
                    border: 1px solid #000;
                    border-radius: 5px;
                    box-sizing: border-box;
                }
            }   
        }
    }
}
    .add-new-mask{
        background: transparent;
        width: 100%;
        height: 100%;
        top: 0;
        z-index: 3;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
        position: fixed;
        .add-new-data{
            position: fixed;
            width: 320px;
            height: 100px;
            top: 300px;
            left: 0;
            right: 0;
            margin: auto;
            border: 1px solid #000;
            background: #fff;
            display: flex;
            padding: 12px 12px 12px 12px;
            box-sizing: border-box;
            flex-direction: column;
            z-index: 3;
            .add-new-title{
                text-align: left;
                margin-bottom: 10px;
                color: #333;
            }
            input{
                height: 30px;
                border: 1px solid #000;
                border-radius: 6px;
                outline: none;
                padding-left: 15px;
            }
            span{
                cursor: pointer;
                color: #333;
            }
        }
    }
</style>